import React from 'react';
import { useEffect, useRef, useState } from 'react';
/*
showing / hiding is more complex when you add animation. the hidden state should be display-none for accessibility reasons,
but css doesn't know how to animate out of that. so you need to add intermediate steps that css can animate.

shown <> visible <> invisible <> hidden

hidden (permanent state)
  display: none

invisible (transition state)
  display: block
  opacity: 0
  height: 0
  overflow: hidden
  transition: all 0.3s ease

visible (transition state)
  display: block
  opacity: 1
  height: ???px
  overflow: hidden
  transition: all 0.3s ease

shown (permanent state)
  display: block
*/
export function Expand({ show, children, time = 350 }) {
    var _a;
    const startTimer = useRef(null);
    const endTimer = useRef(null);
    const container = useRef(null);
    const styles = {
        hidden: {
            display: 'none'
        },
        invisible: {
            opacity: 0,
            overflow: 'hidden',
            transition: `opacity ${time}ms, height ${time}ms`
        },
        visible: {
            opacity: 1,
            overflow: 'hidden',
            transition: `opacity ${time}ms, height ${time}ms`
        },
        shown: {}
    };
    const [status, setStatus] = useState({
        visibility: show ? 'shown' : 'hidden',
        height: show ? (_a = container.current) === null || _a === void 0 ? void 0 : _a.scrollHeight : 0
    });
    useEffect(() => {
        var _a, _b;
        if (show === true) {
            if (status.visibility === 'hidden') {
                setStatus({
                    visibility: 'invisible',
                    height: 0
                });
            }
            else if (status.visibility === 'invisible') {
                //get height
                setStatus({
                    visibility: 'visible',
                    height: (_a = container.current) === null || _a === void 0 ? void 0 : _a.scrollHeight
                });
                if (endTimer.current) {
                    clearTimeout(endTimer.current);
                }
                endTimer.current = setTimeout(() => {
                    setStatus({
                        visibility: 'shown'
                    });
                }, time);
            }
        }
        else if (show === false) {
            if (status.visibility === 'shown') {
                setStatus({
                    visibility: 'visible',
                    height: (_b = container.current) === null || _b === void 0 ? void 0 : _b.scrollHeight
                });
            }
            else if (status.visibility === 'visible') {
                if (startTimer.current) {
                    clearTimeout(startTimer.current);
                }
                startTimer.current = setTimeout(() => {
                    setStatus({
                        visibility: 'invisible',
                        height: 0
                    });
                }, 50);
                if (endTimer.current) {
                    clearTimeout(endTimer.current);
                }
                endTimer.current = setTimeout(() => {
                    setStatus({ visibility: 'hidden' });
                }, time);
            }
        }
    }, [show, status]);
    //clean up
    useEffect(() => {
        return () => {
            if (startTimer.current) {
                clearTimeout(startTimer.current);
            }
            if (endTimer.current) {
                clearTimeout(endTimer.current);
            }
        };
    }, []);
    return (React.createElement("div", { style: Object.assign(Object.assign({}, styles[status.visibility]), { height: status.height }), ref: container }, children));
}
//# sourceMappingURL=Expand.js.map